import { httpService } from "@/api/httpService"
const imageBrowsing = {
  state: {
     // 错误信息
     errorInfo:{
     },
    seriesDataList: [],
    imageTiaoChuang: [],
    viewportList: [
      {
        style: {
          width: "100%",
          height: "100%"
        },
        ac: true,
        topLeft: [],
        topRight: [],
        bottomRight: [],
        bottomLeft: []
      }
    ],
    useMPR: false,
    // 记录要显示的tags 4角标注信息 支持配置文件读取
    fourCornerMarkConfig: {
      topLeft: ["x00100020", "x00100010", "x00100030"],
      topRight: ["x00080080", "x00080020", "x00080060"],
      bottomRight: [],
      bottomLeft: []
    },
    fourCornerMarkDataParse: {
      topLeft: [],
      topRight: [],
      bottomRight: [],
      bottomLeft: []
    }
  },
  mutations: {
    // 收集错误信息
    ERRORINFO(state, errInfo){
      state.errorInfo = Object.assign(state.errorInfo,errInfo);
    },
    // 清楚错误信息
    CLEARERRORINFO(state){
      state.errorInfo = {}
    },
    USEMPR(state, B) {
      state.useMPR = B
    },
    SET_VIEWPORT: (state, viewportList) => {
      state.viewportList = viewportList
    },
    SET_IMAGE_TIAO_CHUANG: (state, viewportList) => {
      state.imageTiaoChuang = viewportList
    },
    GET_IMAGE_BROWSING_INFO: (state, info) => {
      state.seriesDataList = info
    }
  },
  actions: {
    // 错误信息
    errorInfo( { state, commit, dispatch },errInfo){
      commit("ERRORINFO", errInfo);
    },
    // 初始化
    clearErrorInfo({commit}){
      commit("CLEARERRORINFO");
    },
    // 设置 默认的四角标注tags
    setdefaultMarkFromNote({ state, commit ,rootState, dispatch}) {
      return new Promise((resolve, reject) => {
        // 获取seriesDataList的第一个对象中的
        const imageId = state.seriesDataList[0].getDcmFilePath[0]
        cornerstone.loadImage(imageId).then(async (image) => {
          if (image && image.data && image.data.byteArray) {
            let byteArray = image.data.byteArray
            var dataSet = dicomParser.parseDicom(byteArray /*, options */)
            //
            for (let item in state.fourCornerMarkConfig) {
              // state.fourCornerMarkConfig[item]
              for (
                let i = 0;
                i < state.fourCornerMarkConfig[item].length;
                i++
              ) {

                //判断字符集编码类型
                let characterSet = dataSet.string("x00080005");
                let dicomParserTag = ''
                console.log('characterSet',characterSet)
                // 现场的 characterSet  GB18030 、 ISO_IR_100（不支持中文 但是返回的dcm文件会有中文）
                if (1) {
                // if (characterSet == "GB18030") {
                  function readFixedString(
                    byteArray,
                    position,
                    length
                  ) {
                    if (length < 0) {
                      throw "dicomParser.readFixedString - length cannot be less than 0";
                    }
                    if (position + length > byteArray.length) {
                      throw "dicomParser.readFixedString: attempt to read past end of buffer";
                    }
                    let byteArr = [];
                    for (let i = 0; i < length; i++) {
                      let byte = byteArray[position + i];
                      byteArr.push(byte);
                    }
                    return byteArr;
                  }

                  function stringChinese  (tag, data, callback) {
                    let element = data.elements[tag];
                    if (element && element.length > 0) {
                      let fixedString = readFixedString(
                        data.byteArray,
                        element.dataOffset,
                        element.length
                      );
                      let array = new Uint8Array(fixedString);
                      let blob = new Blob([array]);
                      let reader = new FileReader();
                      reader.readAsText(blob, characterSet);
                      reader.onload = callback;
                    } else {
                      callback({
                        target: {
                          result: ""
                        }
                      });
                    }
                  }

                   stringChinese(`${state.fourCornerMarkConfig[item][i]}`, image.data, function(
                    e
                  ) {
                    // 获取是否开启mate标签加密
                    dicomParserTag = e.target.result;
                    if(rootState.home.encryptionEnabledFlag  == "Y"){
                      // 调用解密代码
                      dispatch('encryptionEnabled',dicomParserTag).then((tag)=>{
                        state.fourCornerMarkDataParse[item].push(tag)
                      })
                    }else{
                      state.fourCornerMarkDataParse[item].push(dicomParserTag)
                    }
                  });
                } else {
                  dicomParserTag = dataSet.string(
                    `${state.fourCornerMarkConfig[item][i]}`
                  )

                  state.fourCornerMarkDataParse[item].push(dicomParserTag)
                }
              }
            }

            resolve(state.fourCornerMarkDataParse)
          }
        })
      })
    },
    // 初始化 四角标注tags
    resetdefaultMark({state}){
      state.fourCornerMarkDataParse = {
        topLeft: [],
        topRight: [],
        bottomRight: [],
        bottomLeft: []
      }
    },
    // 更新合并四角标注
    updateViewportMeta() {},
    updateUseMPR({ commit }, B) {
      commit("USEMPR", B)
    },
    setViewportList({ commit }, viewportList) {
      commit("SET_VIEWPORT", viewportList)
    },
    updateViewportStatus({ commit }, { viewport }) {
      const { viewportList } = this.state.imageBrowsing
      viewportList.forEach((element) => {
        element.ac = false
      })
      viewport.ac = true
      commit("SET_VIEWPORT", viewportList)
    },
    updateViewportMeta({ commit }, { viewportData, index }) {
      const { viewportList } = this.state.imageBrowsing
      viewportList[index] = viewportData
      commit("SET_VIEWPORT", viewportList)
    },
    getImageBrowsingInfo({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        httpService({
          url: "getImageBrowsingData",
          method: "get",
          params: params
        })
          .then((response) => {
            response.result.forEach((ele,i) => {
              if (ele.fileTypeName && ele.fileTypeName != "dcm") {
                ele.getDcmFilePath = ele.getDcmFilePath.map((_ele,_index) => {
                  //如果是bmp文件 设置mate元数据
                  function metaDataProvider(type, imageId) {
                    if (type === "imagePlaneModuleCustom") {
                        if (imageId === (location.origin + _ele)) {
                            return {
                                imageIndex: _index + 1
                            };
                        }
                    }
                  }
                  cornerstone.metaData.addProvider(metaDataProvider);
                  return location.origin + _ele;
                })
              }else{
                ele.getDcmFilePath = ele.getDcmFilePath.map((_ele,_index) => {
                   return `wadouri:${_ele}`
                })
              }
            })
            response.result.forEach((item, index) => {
              item.percentage = undefined // 监听缩略图的进度条
            })
            commit("GET_IMAGE_BROWSING_INFO", response.result);
            dispatch("setdefaultMarkFromNote")
            resolve(response.result)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getImageTiaoChuang({ commit }, params) {
      return new Promise((resolve, reject) => {
        httpService({
          url: "getImageTiaoChuangData",
          method: "post",
          data: params
        })
          .then((response) => {
            if (response.result && response.result.htmlData) {
              var _htmlData = JSON.parse(response.result.htmlData)
              commit("SET_IMAGE_TIAO_CHUANG", _htmlData)
            }
            resolve(response.result)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 解密
    encryptionEnabled({ commit },str){
      return new Promise((resolve, reject) => {
        httpService({
          url: "aesDecrypt",
          method: "post",
          data: {
            aesString:str
          }
        }).then((response) => {
          resolve(response.result)
        })
      })
    }
  }
}

export default imageBrowsing
